<!-- <div class="relative-class">
        <div class="closeBtn" (click)="closeModal()">
            <img src="../../../../../assets/images/crossbtn.svg" />
        </div>
        <div>
            Lorem ipsum dolor sit amet consectetur, adipisicing elit. Recusandae impedit autem vero optio assumenda vitae similique aliquid hic, sint officia expedita! Ipsa aspernatur minima doloribus, iure iste earum voluptatum id voluptas. Aperiam sit a similique consequuntur excepturi asperiores recusandae id temporibus vitae ducimus, commodi odit neque possimus repellendus labore harum!
        </div>
</div> -->

<div class="modall">
    <div class="modal-contentt">
      <video (ended)="onVideoEnded()" class="videoPlayerFullModal" id="video-player"
        width="100%" height="100%" controls autoplay muted playsinline>
        <source src="../../assets/images/install-ios-app.mp4" type="video/mp4">
      </video>
      <button class="closeBtn" (click)="onVideoEnded()">
        <img src="../../../../../assets/images/close.png" alt="">
      </button>
    </div>
  </div>
